import Component from '@glimmer/component';
import { or } from 'tio-ui/utilities';
import Button from './button';
import { PhArrowsClockwise } from 'ember-phosphor-icons';
import type { ButtonIntent } from './button';

interface FooterSignatureBase {
  isRunning?: boolean;
  onSubmit: () => void;
  submitText?: string;
  submitDisabled?: boolean;
  submitIntent?: ButtonIntent;
}

interface FooterWithCancel {
  Args: FooterSignatureBase & {
    onCancel: () => void;
    cancelText?: string;
  };
  Blocks: {
    left: [];
  };
}

interface FooterWithoutCancel {
  Args: FooterSignatureBase & {
    onCancel?: undefined;
    cancelText?: never;
  };
  Blocks: {
    left: [];
  };
}

type FooterSignature = FooterWithCancel | FooterWithoutCancel;

export default class Footer extends Component<FooterSignature> {
  get submitIntent(): ButtonIntent {
    return this.args.submitIntent ?? 'primary';
  }

  <template>
    {{! Spinner Div: Show and fade in when submitTask is running }}
    <div
      class="transition-opacity duration-500 ease-in-out
        {{if @isRunning 'opacity-100' 'opacity-0 pointer-events-none'}}
        tio-row-center absolute inset-0"
    >
      <PhArrowsClockwise @size="24" class="animate-spin" />
    </div>

    {{! Button Div: Fade out when submitTask is running }}
    <div
      class="transition-opacity duration-500 ease-in-out
        {{if @isRunning 'opacity-0 pointer-events-none' 'opacity-100'}}
        flex justify-between w-full gap-x-4"
    >
      <div>
        {{yield to="left"}}
      </div>
      <div>
        {{#if @onCancel}}
          <Button
            {{on "click" @onCancel}}
            @appearance="outlined"
            @intent="danger"
            data-test-modal-cancel
          >
            {{or @cancelText "Cancel"}}
          </Button>
        {{/if}}
        <Button
          {{on "click" @onSubmit}}
          @intent={{this.submitIntent}}
          @isDisabled={{@submitDisabled}}
          data-test-modal-submit
        >
          {{or @submitText "Submit"}}
        </Button>
      </div>
    </div>
  </template>
}
